import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

// User Management
export const getAllUsers = async () => {
  try {
    const response = await axiosInstance.get('/Account/get-all-users');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getUserById = async (userId) => {
  try {
    const response = await axiosInstance.get('/Account/get-user-by-id', {
      params: { userId }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const searchUsers = async (searchTerm) => {
  try {
    const response = await axiosInstance.get('/Account/search-user', {
      params: { searchTerm }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createUser = async (userData) => {
  try {
    const response = await axiosInstance.post('/Account/admin/create-user', userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateUser = async (userId, userData) => {
  try {
    const response = await axiosInstance.put(`/Account/users/${userId}`, userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteUser = async (userId) => {
  try {
    const response = await axiosInstance.delete('/Account/delete-user', {
      data: { userId }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const enableUser = async (userId) => {
  try {
    const response = await axiosInstance.post('/Account/user-enable', { userId });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const disableUser = async (userId) => {
  try {
    const response = await axiosInstance.post('/Account/user-disable', { userId });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateUserPassword = async (userId, newPassword, confirmPassword) => {
  try {
    const response = await axiosInstance.post('/Account/admin/change-password', {
      userId: userId,
      newPassword: newPassword,
      confirmPassword: confirmPassword
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Role Management
export const getAvailableRoles = async () => {
  try {
    const response = await axiosInstance.get('/Account/available-roles');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const changeUserRole = async (userId, roleName) => {
  try {
    const response = await axiosInstance.post('/Account/change-user-role', { 
      UserId: userId, 
      RoleName: roleName 
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const removeRoleFromUser = async (userId, roleName) => {
  try {
    const response = await axiosInstance.post('/Account/remove-user-role', { userId, roleName });
    return response.data;
  } catch (error) {
    throw error;
  }
};
